
var blockReferrer = ['adspy.com', '0refer.com', 'spybadao.com', 'spypro.io', 'pipiads.com', 'shophunter.io', 'shophunter.com', 'dropship.io'];
      var cName = "__clfref"; function setCookie(e,o,t=2147483647){var n=new Date;n.setTime(n.getTime()+t);var r="expires="+n.toUTCString();document.cookie=e+"="+o+";"+r+";path=/"}function getCookie(e){for(var o=e+"=",t=decodeURIComponent(document.cookie).split(";"),n=0;n<t.length;n++){for(var r=t[n];" "==r.charAt(0);)r=r.substring(1);if(0==r.indexOf(o))return r.substring(o.length,r.length)}return""}function delete_cookie(e){document.cookie=e+"=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;"}document.addEventListener('DOMContentLoaded', function(){var e=window.location.hostname;-1!=document.referrer.indexOf(e+"/admin")&&delete_cookie(cName),""!=getCookie(cName)?window.location.href="http://google.com/not-found":document.referrer&&""!=document.referrer&&blockReferrer.some(function(e){if(-1!==document.referrer.indexOf(e))return setCookie(cName,1),window.location.href="https://www.google.com/not-found",!0})});
      var spyTools = ["Ali Hunter", "PPSPY", "Commerce Inspector"];
      var userAgent = window.navigator.userAgent;
      for (var i = 0; i < spyTools.length; i++) {
        if (userAgent.indexOf(spyTools[i]) !== -1) {
          window.location.href = "https://www.example.com/blocked.html"; // Replace with the URL you want to redirect the spy tools to
        }
      }



        const productForm = document.querySelector('product-form[data-main="true"]');
      if (productForm) {
        document.querySelectorAll('[id^="SectionAtcBtn-"]').forEach(btn => {
          btn.addEventListener('click', (e) => {
            productForm.handleSubmit(e);
          })
        })
      }

      

      (function () {
        var links = document.links;
        for (let i = 0; i < links.length;  i++) {
          if (links[i].hostname !== window.location.hostname) {
            links[i].target = '_blank';
            links[i].rel = 'noreferrer noopener';
          }
        }
      })();

    
        // window.addEventListener("contextmenu", (e) => {
        //   e.preventDefault();
        // });
        // document.addEventListener("selectstart", (e) => {
        //   e.preventDefault();
        // });
        // document.addEventListener('DOMContentLoaded', function() {
        //   document.querySelectorAll('img').forEach(img => {
        //     img.addEventListener('dragstart', function(e) {
        //       e.preventDefault();
        //     })
        //   }) 
        // })
        // function ctrlShiftKey(e, keyCode) {
        //   return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
        // }
        // document.addEventListener('keydown', function(e) {
        //   if (
        //     event.keyCode === 123 ||
        //     ctrlShiftKey(e, 'I') ||
        //     ctrlShiftKey(e, 'J') ||
        //     ctrlShiftKey(e, 'C') ||
        //     (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0))
        //   ) {
        //     e.preventDefault();
        //   }
        // })
      



// $(document).ready(function () {
// setTimeout(function () {
//  const variantId = 51351127884049;
//     // const selling_plan = 12374802705; 



//     if (!variantId) return; 

//     $.ajax({
//         type: 'GET',
//         url: '/cart.js',
//         dataType: 'json',
//         success: function (cart) {
//             let variantInCart = false;
//             cart.items.forEach(item => {
//                 if (item.id == variantId) {
//                     variantInCart = true;
//                 }
//             });

//             if (variantInCart) {
//                 $.ajax({
//                     type: 'POST',
//                     url: '/cart/update.js',
//                     data: {
//                         updates: {
//                             [variantId]: 1
//                         }
//                     },
//                     dataType: 'json',
//                     success: function () {
//                       console.log('Variant quantity updated to 1.');

//                     },
//                     error: function () {
//                         console.error('Error updating cart.');
//                     }
//                 });
//             } else {
            
//                 $.ajax({
//                     type: 'POST',
//                     url: '/cart/add.js',
//                     data: {
//                         id: variantId,
//                         quantity: 1
                      
//                     },
//                     dataType: 'json',
//                     success: function () {
//                         console.log('Variant added to cart.');

//                     },
//                     error: function () {
//                         console.error('Error adding to cart.');
//                     }
//                 });
//             }
//         },
//         error: function () {
//             console.error('Error fetching cart data.');
//         }
//     });
// }, 500);
  
// });


// $(".vip_add_to_cart").click(function(e) {

//     e.preventDefault(); 
//     $('label[new_dattta="VIP Price"]').click();
//     setTimeout(function() {
//      $('.atc-button.vip_add_to_cart').css('opacity', '0.7');
//      $('.text_aatc').hide();
//      $('span.loader.dat_all').show();
//         $('.vip_guest_add_to_cart').click();
//     }, 500); 

//  setTimeout(function() {
// $('span.loader.dat_all').hide();
// $('.text_aatc').show();
// $('.atc-button.vip_add_to_cart').css('opacity', '1');

//  },2500);

// setTimeout(function () {
//  // const variantId = $('.vip_add_to_cart').attr('data_var_id');
//  //    const selling_plan = $('.vip_add_to_cart').attr('selling_plan');
//  const variantId = 51351127884049;
//     // const selling_plan = 12374802705; 
//     if (!variantId) return; 

//     $.ajax({
//         type: 'GET',
//         url: '/cart.js',
//         dataType: 'json',
//         success: function (cart) {
//             let variantInCart = false;
//             cart.items.forEach(item => {
//                 if (item.id == variantId) {
//                     variantInCart = true;
//                 }
//             });

//             if (variantInCart) {
//                 $.ajax({
//                     type: 'POST',
//                     url: '/cart/update.js',
//                     data: {
//                         updates: {
//                             [variantId]: 1
//                         }
//                     },
//                     dataType: 'json',
//                     success: function () {
//                        // alert('Variant quantity updated to 1.');

//  setTimeout(function() {
//  window.location.href = "/checkout";
//  },500);

 


//                     },
//                     error: function () {
//                         console.error('Error updating cart.');
//                     }
//                 });
//             } else {
            
//                 $.ajax({
//                     type: 'POST',
//                     url: '/cart/add.js',
//                     data: {
//                         id: variantId,
//                         quantity: 1
                       
//                     },
//                     dataType: 'json',
//                     success: function () {
//                       // alert('Variant added to cart.');
//  setTimeout(function() {
//   window.location.href = "/checkout";
//  },500);




//                     },
//                     error: function () {
//                         console.error('Error adding to cart.');
//                     }
//                 });
//             }
//         },
//         error: function () {
//             console.error('Error fetching cart data.');
//         }
//     });
// }, 1500);


// });

   
        

// $(".sticky-atc__button.btn_22").click(function(e) {
//     e.preventDefault(); 
//     $('label[new_dattta="VIP Price"]').click();
//     setTimeout(function() {
//      $('.sticky-atc__button.btn_22').css('opacity', '0.7');
//      $('.text_aatc').hide();
//      $('span.loader2.dat_all').show();
//         $('.vip_guest_add_to_cart').click();
//     }, 500); 

//  setTimeout(function() {
// $('span.loader2.dat_all').hide();
// $('.text_aatc').show();
// $('.sticky-atc__button.btn_22').css('opacity', '1');

//  },2500);

// setTimeout(function () {
//  // const variantId = $('.vip_add_to_cart').attr('data_var_id');
//  //    const selling_plan = $('.vip_add_to_cart').attr('selling_plan');
//  const variantId = 51351127884049;
//     // const selling_plan = 12374802705; 
//     if (!variantId) return; 

//     $.ajax({
//         type: 'GET',
//         url: '/cart.js',
//         dataType: 'json',
//         success: function (cart) {
//             let variantInCart = false;
//             cart.items.forEach(item => {
//                 if (item.id == variantId) {
//                     variantInCart = true;
//                 }
//             });

//             if (variantInCart) {
//                 $.ajax({
//                     type: 'POST',
//                     url: '/cart/update.js',
//                     data: {
//                         updates: {
//                             [variantId]: 1
//                         }
//                     },
//                     dataType: 'json',
//                     success: function () {
//                        // alert('Variant quantity updated to 1.');

//  setTimeout(function() {
//  window.location.href = "/checkout";
//  },500);

 


//                     },
//                     error: function () {
//                         console.error('Error updating cart.');
//                     }
//                 });
//             } else {
            
//                 $.ajax({
//                     type: 'POST',
//                     url: '/cart/add.js',
//                     data: {
//                         id: variantId,
//                         quantity: 1
                       
//                     },
//                     dataType: 'json',
//                     success: function () {
//                       // alert('Variant added to cart.');
//  setTimeout(function() {
//   window.location.href = "/checkout";
//  },500);




//                     },
//                     error: function () {
//                         console.error('Error adding to cart.');
//                     }
//                 });
//             }
//         },
//         error: function () {
//             console.error('Error fetching cart data.');
//         }
//     });
// }, 1500);


// });











// $(".guest_add_to_cart").click(function(e) {
//     e.preventDefault(); 
//     $('label[new_dattta="Guest Price"]').click();
//     setTimeout(function() {
//         $('.vip_guest_add_to_cart').click();
//     }, 2000); 
// });

// $(".vip_guest_add_to_cart ").click(function(e) {
// setTimeout(function() {
// window.location.href = "/checkout";
// },2000);
// });



$(document).ready(function () {
    $(window).scroll(function () {
        let scrollPercentage = ($(window).scrollTop() / ($(document).height() - $(window).height())) * 100;

        if (scrollPercentage > 10) {
            $('.sticky-atc').attr('style', 'transform: none !important;');
        }
    });
});



$(document).ready(function () {
  $(".quantity__button").on("click", function () {
    let inputField = $(this).siblings(".quantity__input");
    let currentValue = parseInt(inputField.val(), 10);
    $('input.input_quantity').val(currentValue);
  });
});



// //////////////////////////////
//    $(document).ready(function(){
//  setTimeout(function() {

//        var selectedValue =  $('input.product-variant-id').val();
//     // alert(selectedValue);

//     var currency = $('.variants_datat').attr('currentcy'); 
//         var vip = "VIP Price";  
//         var guest = "Guest Price";  
//      let variantWrapperCount = $(".product-form__input.product-form__input--pills").length;
//         // console.log(variantWrapperCount);

//         if (variantWrapperCount === 1) {
//                // alert(variantWrapperCount);
//             var titl_data1 = $('.variants_datat option[title="'+vip+'"]').attr('price') || "0";
//             var vip_price = currency + "" + titl_data1;
//             console.log(vip_price);
//            $('.vip_add_to_cart .vip' ).text(vip_price);
//             var titl_data2 = $('.variants_datat option[title="'+guest+'"]').attr('price') || "0";
//             var guest_price = currency + "" + titl_data2;
//             console.log(guest_price);
//               $('.guest_add_to_cart .guest' ).text(guest_price);
            
//         } else if (variantWrapperCount === 2) {
//              console.log(variantWrapperCount);
//     var titl_data3 = $('.variants_datat option[value="'+selectedValue+'"]').attr('title') || '';
//    // alert(titl_data3);
            
//  if (titl_data3.includes("VIP Price")) {
// var titl_data44 = $('.variants_datat option[value="'+selectedValue+'"]').attr('title');

// if (titl_data44 && titl_data44.includes("VIP Price")) {
//     titl_data44 = titl_data44.replace("VIP Price", "Guest Price");
//      var titl_data45 = $('.variants_datat option[title="'+titl_data44+'"]').attr('price') || "0";
//       var vip_price_45 = currency + "" + titl_data45;
//      $('.guest_add_to_cart .guest ' ).text(vip_price_45);
// }
            
//       var titl_data4 = $('.variants_datat option[value="'+selectedValue+'"]').attr('price') || "0";
//       var vip_price_4 = currency + "" + titl_data4;
//       $('.vip_add_to_cart .vip ' ).text(vip_price_4);

     
// } else if (titl_data3.includes("Guest Price")) {

//  var titl_data455 = $('.variants_datat option[value="'+selectedValue+'"]').attr('price') || "0";
//       var vip_price_444 = currency + "" + titl_data455;
//  $('.guest_add_to_cart .guest ' ).text(vip_price_444);
     
// var titl_data44a = $('.variants_datat option[value="'+selectedValue+'"]').attr('title');
     
// if (titl_data44a && titl_data44a.includes("Guest Price")) {
//     titl_data44a = titl_data44a.replace("Guest Price", "VIP Price");
//      var titl_data456 = $('.variants_datat option[title="'+titl_data44a+'"]').attr('price') || "0";
//       var titl_data456 = currency + "" + titl_data456;
//     // alert(titl_data456);
//      $('.vip_add_to_cart .vip' ).text(titl_data456);
// }
     
// }   
//         }else if (variantWrapperCount === 3) {
//               // alert(variantWrapperCount);

//     var titl_data3 = $('.variants_datat option[value="'+selectedValue+'"]').attr('title');
//    // alert(titl_data3);
            
//  if (titl_data3.includes("VIP Price")) {
// var titl_data44 = $('.variants_datat option[value="'+selectedValue+'"]').attr('title');

// if (titl_data44 && titl_data44.includes("VIP Price")) {
//     titl_data44 = titl_data44.replace("VIP Price", "Guest Price");
//      var titl_data45 = $('.variants_datat option[title="'+titl_data44+'"]').attr('price') || "0";
//       var vip_price_45 = currency + "" + titl_data45;
//      $('.guest_add_to_cart .guest' ).text(vip_price_45);
// }
            
//       var titl_data4 = $('.variants_datat option[value="'+selectedValue+'"]').attr('price') || "0";
//       var vip_price_4 = currency + "" + titl_data4;
//       $('.vip_add_to_cart .vip' ).text(vip_price_4);

     
// } else if (titl_data3.includes("Guest Price")) {

//  var titl_data455 = $('.variants_datat option[value="'+selectedValue+'"]').attr('price') || "0";
// // alert(titl_data455);
//       var vip_price_444 = currency + "" + titl_data455;
//  $('.guest_add_to_cart .guest' ).text(vip_price_444);
     
// var titl_data44a = $('.variants_datat option[value="'+selectedValue+'"]').attr('title');
     
// if (titl_data44a && titl_data44a.includes("Guest Price")) {
//     titl_data44a = titl_data44a.replace("Guest Price", "VIP Price");
//      var titl_data456 = $('.variants_datat option[title="'+titl_data44a+'"]').attr('price') || "0";
//       var titl_data456 = currency + "" + titl_data456;
//     // alert(titl_data456);
//      $('.vip_add_to_cart .vip' ).text(titl_data456);
// }
     
// }   
//         } 
//  },500);

// });


// $(document).on("click", ".product-form__input label", function() {
//   // var var_id =  $('input.product-variant-id').val();
//   //   console.log(var_id);

//  setTimeout(function() {

//        var selectedValue =  $('input.product-variant-id').val();
//     // alert(selectedValue);

//     var currency = $('.variants_datat').attr('currentcy'); 
//         var vip = "VIP Price";  
//         var guest = "Guest Price";  
//      let variantWrapperCount = $(".product-form__input.product-form__input--pills").length;
//         // console.log(variantWrapperCount);

//         if (variantWrapperCount === 1) {
//                // alert(variantWrapperCount);
//             var titl_data1 = $('.variants_datat option[title="'+vip+'"]').attr('price') || "0";
//             var vip_price = currency + "" + titl_data1;
//             console.log(vip_price);
//            $('.vip_add_to_cart .vip' ).text(vip_price);
//             var titl_data2 = $('.variants_datat option[title="'+guest+'"]').attr('price') || "0";
//             var guest_price = currency + "" + titl_data2;
//             console.log(guest_price);
//               $('.guest_add_to_cart .guest' ).text(guest_price);
            
//         } else if (variantWrapperCount === 2) {
//              console.log(variantWrapperCount);
//     var titl_data3 = $('.variants_datat option[value="'+selectedValue+'"]').attr('title');
//    // alert(titl_data3);
            
//  if (titl_data3.includes("VIP Price")) {
// var titl_data44 = $('.variants_datat option[value="'+selectedValue+'"]').attr('title');

// if (titl_data44 && titl_data44.includes("VIP Price")) {
//     titl_data44 = titl_data44.replace("VIP Price", "Guest Price");
//      var titl_data45 = $('.variants_datat option[title="'+titl_data44+'"]').attr('price') || "0";
//       var vip_price_45 = currency + "" + titl_data45;
//      $('.guest_add_to_cart .guest ' ).text(vip_price_45);
// }
            
//       var titl_data4 = $('.variants_datat option[value="'+selectedValue+'"]').attr('price') || "0";
//       var vip_price_4 = currency + "" + titl_data4;
//       $('.vip_add_to_cart .vip ' ).text(vip_price_4);

     
// } else if (titl_data3.includes("Guest Price")) {

//  var titl_data455 = $('.variants_datat option[value="'+selectedValue+'"]').attr('price') || "0";
//       var vip_price_444 = currency + "" + titl_data455;
//  $('.guest_add_to_cart .guest ' ).text(vip_price_444);
     
// var titl_data44a = $('.variants_datat option[value="'+selectedValue+'"]').attr('title');
     
// if (titl_data44a && titl_data44a.includes("Guest Price")) {
//     titl_data44a = titl_data44a.replace("Guest Price", "VIP Price");
//      var titl_data456 = $('.variants_datat option[title="'+titl_data44a+'"]').attr('price') || "0";
//       var titl_data456 = currency + "" + titl_data456;
//     // alert(titl_data456);
//      $('.vip_add_to_cart .vip' ).text(titl_data456);
// }
     
// }   
//         }else if (variantWrapperCount === 3) {
//               // alert(variantWrapperCount);

//     var titl_data3 = $('.variants_datat option[value="'+selectedValue+'"]').attr('title');
//    // alert(titl_data3);
            
//  if (titl_data3.includes("VIP Price")) {
// var titl_data44 = $('.variants_datat option[value="'+selectedValue+'"]').attr('title');

// if (titl_data44 && titl_data44.includes("VIP Price")) {
//     titl_data44 = titl_data44.replace("VIP Price", "Guest Price");
//      var titl_data45 = $('.variants_datat option[title="'+titl_data44+'"]').attr('price') || "0";
//       var vip_price_45 = currency + "" + titl_data45;
//      $('.guest_add_to_cart .guest' ).text(vip_price_45);
// }
            
//       var titl_data4 = $('.variants_datat option[value="'+selectedValue+'"]').attr('price') || "0";
//       var vip_price_4 = currency + "" + titl_data4;
//       $('.vip_add_to_cart .vip' ).text(vip_price_4);

     
// } else if (titl_data3.includes("Guest Price")) {

//  var titl_data455 = $('.variants_datat option[value="'+selectedValue+'"]').attr('price') || "0";
// // alert(titl_data455);
//       var vip_price_444 = currency + "" + titl_data455;
//  $('.guest_add_to_cart .guest' ).text(vip_price_444);
     
// var titl_data44a = $('.variants_datat option[value="'+selectedValue+'"]').attr('title');
     
// if (titl_data44a && titl_data44a.includes("Guest Price")) {
//     titl_data44a = titl_data44a.replace("Guest Price", "VIP Price");
//      var titl_data456 = $('.variants_datat option[title="'+titl_data44a+'"]').attr('price') || "0";
//       var titl_data456 = currency + "" + titl_data456;
//     // alert(titl_data456);
//      $('.vip_add_to_cart .vip' ).text(titl_data456);
// }
     
// }   
//         } 
//  },500);

// });



// ///////////////////////////////////////////
// $(document).ready(function() {
//    if (window.location.pathname.includes("/cart")) {
//         setTimeout(function() {
//             $.ajax({
//                 url: "/cart.js",
//                 type: "GET",
//                 dataType: "json",
//                 success: function(cart) {
//                     let hasVIP = false;
//                     let hasVariant = false;
                    
//                     cart.items.forEach(function(item) {
//                         if (item.id == 51351127884049) {
//                             hasVariant = true;
//                         }
//                     });


// $(".cart-item").each(function () {
//     let optionName = $(this).attr("option_name"); 
//     if (optionName && optionName.includes("VIP Price")) { 
//        hasVIP = true;
//             // alert('hiiiii');
//     } 
// });


//                     if (!hasVIP && hasVariant) {
//                                     // alert('byyyyyy');
//                           setTimeout(function() {
//                     $('.cart-item[item_id="51351127884049"] cart-remove-button').click();
//                           },2000);
//                     } else {
                      
//                     }
//                 },
//                 error: function(xhr, status, error) {
//                     console.error("Error fetching cart data:", error);
//                 }
//             });

         

//         }, 2000);
//     }
// });



// $(document).on('click', '.cart-item cart-remove-button', function(){
//    if (window.location.pathname.includes("/cart")) {

//         setTimeout(function() {
//             $.ajax({
//                 url: "/cart.js",
//                 type: "GET",
//                 dataType: "json",
//                 success: function(cart) {
//                     let hasVIP = false;
//                     let hasVariant = false;
                    
//                     cart.items.forEach(function(item) {
//                         if (item.id == 51351127884049) {
//                             hasVariant = true;
//                         }
//                     });


// $(".cart-item").each(function () {
//     let optionName = $(this).attr("option_name"); 
//     if (optionName && optionName.includes("VIP Price")) { 
//        hasVIP = true;
//             // alert('hiiiii');
//     } 
// });


//                     if (!hasVIP && hasVariant) {
//                                     // alert('byyyyyy');
//                           setTimeout(function() {
//                     $('.cart-item[item_id="51351127884049"] cart-remove-button').click();
//                           },2000);
//                     } else {
                      
//                     }
//                 },
//                 error: function(xhr, status, error) {
//                     console.error("Error fetching cart data:", error);
//                 }
//             });

         

//         }, 2000);
//     }
 
// });



      // hide kaachin bundle variants on load//
      // $('.quantity-break__selector-item .select[data_value="User Type"]').closest('.quantity-break__variants').hide();

 $('.quantity-break__selector-item .select').show();


 $('.quantity-break__selector-item .select[data_value="User Type"]').hide();

